"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var WebFonts = function WebFonts(_ref) {
  var theme = _ref.theme;

  if (theme.webfonts) {
    var WebFont = require("webfontloader");

    WebFont.load(theme.webfonts);
  }

  return null;
};

var _default = (0, _styledComponents.withTheme)(WebFonts);

exports["default"] = _default;